import { action, flow, makeObservable, observable } from 'mobx';

import { apiFetcher } from '../utils/fetch';
import { updateItems } from './utils';

export default class Expense {
  constructor() {
    this.items = [];
    this.selected = {};
    this.summary = { total: 0, count: 0, byCategory: [], byProperty: [] };
    this.filters = { propertyId: '', category: '', from: '', to: '' };

    makeObservable(this, {
      items: observable,
      selected: observable,
      summary: observable,
      filters: observable,
      setSelected: action,
      setFilters: action,
      fetch: flow,
      fetchSummary: flow,
      create: flow,
      update: flow,
      delete: flow
    });
  }

  setSelected = (expense) => (this.selected = expense || {});
  setFilters = (filters) => (this.filters = { ...this.filters, ...filters });

  *fetch(params = {}) {
    try {
      const search = new URLSearchParams();
      const merged = { ...this.filters, ...params };
      Object.entries(merged).forEach(([k, v]) => {
        if (v) search.append(k, v);
      });
      const qs = search.toString();
      const response = yield apiFetcher().get(
        `/expenses${qs ? `?${qs}` : ''}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status };
    }
  }

  *fetchSummary(params = {}) {
    try {
      const search = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => {
        if (v) search.append(k, v);
      });
      const qs = search.toString();
      const response = yield apiFetcher().get(
        `/expenses/summary${qs ? `?${qs}` : ''}`
      );
      this.summary = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status };
    }
  }

  *create(expense) {
    try {
      const response = yield apiFetcher().post('/expenses', expense);
      this.items = updateItems(response.data, this.items);
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status };
    }
  }

  *update(expense) {
    try {
      const response = yield apiFetcher().patch(
        `/expenses/${expense._id}`,
        expense
      );
      this.items = updateItems(response.data, this.items);
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status };
    }
  }

  *delete(ids) {
    try {
      yield apiFetcher().delete(`/expenses/${ids.join(',')}`);
      this.items = this.items.filter((e) => !ids.includes(e._id));
      return { status: 200 };
    } catch (error) {
      return { status: error?.response?.status };
    }
  }
}
